import { matchPath, useLocation } from 'react-router-dom';

// Copied from https://mui.com/material-ui/integrations/routing/#tabs
function useRouteMatch(patterns) {
    const { pathname } = useLocation();

    for (let i = 0; i < patterns.length; i += 1) {
        const pattern = patterns[i];
        const possibleMatch = matchPath(pattern, pathname);
        if (possibleMatch !== null) {
            return {
                match: possibleMatch,
                currentRoute: possibleMatch.pattern?.path,
            };
        }
    }

    return { match: null, currentRoute: null };
}

export default useRouteMatch;
